var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('TableApp', {
    ref: "grupos",
    attrs: {
      "titulo": "Cadastro de Grupos",
      "acaoBtn": "/#/grupos/novo",
      "textoBtn": "Novo",
      "api-url": "/produtos/lista-grupo",
      "fields": _vm.fields,
      "classFilterColumn": "grupos",
      "perPage": 10,
      "multiselect": _vm.podeCopiarCadastrosEmpresa
    },
    scopedSlots: _vm._u([{
      key: "toolbar-actions",
      fn: function fn() {
        return [_c('CadastroEmpresaCopiarButton', {
          attrs: {
            "modulo": "GRUPO"
          }
        })];
      },
      proxy: true
    }, {
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'actions' ? _c('span', {
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "row-actions",
          staticStyle: {
            "text-align": "right !important"
          }
        }, [_c('span', {
          staticStyle: {
            "overflow": "visible",
            "position": "relative",
            "width": "130px"
          }
        }, [_c('div', {
          staticClass: "dropdown dropdown-inline"
        }, [_c('router-link', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Editar',
            expression: "'Editar'"
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          attrs: {
            "to": {
              name: 'gruposEditar',
              params: {
                id: props.rowData.id
              }
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "size": 16,
            "title": "Editar"
          }
        })], 1), _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip",
            value: 'Excluir',
            expression: "'Excluir'"
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1)], 1)])])]) : _vm._e()];
      }
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };